export enum TagActionMenuEnum {
  ADD = 'ADD',
  EDIT = 'EDIT',
}

export enum TemplateTagEnum {
  ALL = 'ALL',
}
